import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogTableOfContents',
})(({ spacing, brandColors, breakpoints, typography }) => ({
  blogTableOfContents: {
    backgroundColor: brandColors.tintsOffWhite80,
    padding: spacing(2),
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.10)',
    borderRadius: typography.pxToRem(16),
    width: '100%',
    [breakpoints.up('md')]: {
      width: typography.pxToRem(484),
    },
    '& a': {
      display: 'block',
      color: brandColors.tintsNeutral20,
      '&:not(:last-child)': {
        marginBottom: spacing(1),
      },
      '&:hover': {
        color: brandColors.mediumBlue,
      },
    },
  },
  contentsHeader: {
    color: brandColors.black,
    marginBottom: spacing(0),
  },
}));

export default useStyles;
